/**
* @ngdoc directive
* @name Email Input
*
* @description
  Input element with email verification.
*
* @scope
* @param {String} email
* @param {Object} userForm - form where input lives
* @param {Object} errors - optional object that will get input errors
* @param {String} alertClass - optional class added to input error message
* @param {Boolean} isDisabled - optional
* @param {Boolean} optional - is email optional
*
* @example
  <form name='itemForm' ng-init='email="testemail.com"'>
  <email-input
    email="email"
    user-form="itemForm"
    errors="[]"
    alert-class="margin-top-sm clearfix"
  >
  </email-input>
  </form>
*/

(function () {
  emailInput.$inject = ["PATH"];
  app.directive('emailInput', emailInput);

  function emailInput (PATH) {
    var directive = {
      restrict: 'E',
      templateUrl: PATH.components + 'emailInputDirective/emailInput.html',
      scope: {
        email: '=',
        userForm: '=',
        alertClass: '@',
        errors: '=?',
        isDisabled: '=?',
        optional: '@?'
      },
      link: link
    };

    return directive;

    function link ($scope, $element, $attributes) {
      $scope.emailPattern = /^([\w-]+([\.\:\w-\+]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/emailInputDirective/emailInputDirective.js